import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import { DATE_FORMAT, getTimezoneDayjs } from '@/utils/time';

import exportUtils from './exportUtils';

type Props = {
  alias: string;
  title: string;
  created_at: string;
  inProgress: boolean;
  files: HistoryFile[];
};

const ExportHistoryItem = (props: Props) => {
  const onFeedbackDownload = async (alias: string) => {
    await exportUtils.downloadMultipleFiles(alias, props.files);
  };

  return (
    <Style>
      <HeaderWrapper>
        <VFlex g={8} f={1}>
          <Typo type="label2" weight="m" className="text-gray-800">
            {props.title}
          </Typo>
          <Typo type="label3" weight="r" className="text-gray-600">
            {getTimezoneDayjs(props.created_at).format(DATE_FORMAT.readable)}
          </Typo>
        </VFlex>
        <Flex a="center" width="260px" j="flex-end">
          {props.inProgress ? (
            <Typo type="label2" weight="r" className="text-gray-800">
              Exporting...
            </Typo>
          ) : (
            <Flex g={8} a="center">
              <Typo type="label3" weight="r" className="text-gray-600">
                Expire date{' '}
                {getTimezoneDayjs(props.created_at)
                  .addVal(7, 'day')
                  .format(DATE_FORMAT.readable)}
              </Typo>
              <Button onClick={() => onFeedbackDownload(props.alias)}>
                Download
              </Button>
            </Flex>
          )}
        </Flex>
      </HeaderWrapper>
      <BodyWrapper>
        {props.files?.map((file) => (
          <Flex key={file.name}>
            <Typo type="label3" weight="r" className="text-gray-600">
              {file.name}
            </Typo>
          </Flex>
        ))}
      </BodyWrapper>
    </Style>
  );
};

const Style = styled(VFlex)`
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray300};
`;

const HeaderWrapper = styled(Flex)`
  padding: 14px 24px;
  background-color: ${(props) => props.theme.colors.gray250};
  border-radius: 8px;
`;

const BodyWrapper = styled(VFlex)`
  padding: 12px 24px;
  gap: 8px;
`;

export default ExportHistoryItem;
